import React, { useEffect } from "react";
import Image from "next/image";
import styles from "./CtaPopUp.module.scss";
import { getImageType } from "../../utils/helper";
import { useSelector } from "react-redux";

const CTAPopUp = ({ data }) => {
  const { isMobileDevice } = useSelector((state: any) => state.data);

  const title = data?.title;
  const getDescription =
    data?.maintitle?.content?.length > 0 &&
    data?.maintitle?.content[0]?.content[0]?.text;

  useEffect(() => {}, [data]);

  if (!data) {
    return null;
  }

  return (
    <div
      className={`modal fade ${styles.modelnomore}`}
      id="exampleModal2"
      // id={ids ? ids :"exampleModal2"}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-testid="cta-container-id"
    >
      <div className="modal-dialog">
        <div className={`modal-content ${styles.modelwp}`}>
          <div
            className={`modal-header ${
              isMobileDevice ? "justify-content-center" : "justify-content-end"
            }`}
          >
            <button
              className={` ${styles.btnclose}`}
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.9994 15L9 9M9.00064 15L15 9"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                  stroke="white"
                />
              </svg>
            </button>
          </div>
          <div className="modal-body">
            <div className={`row ${styles.bodywp}`}>
              <div className="col-lg-6">
                {data?.image && (
                  <Image
                    src={
                      data?.image && data?.mobileimage
                        ? getImageType(isMobileDevice, data)
                        : data?.image?.results[0]?.fileUrl
                    }
                    alt="slder"
                    width={0}
                    height={0}
                    className={` ${styles.pic}`}
                  />
                )}
              </div>
              <div className="col-lg-6">
                <h4>{title}</h4>
                <p>{getDescription}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTAPopUp;
